import {  Test } from './LoaderStyle'

export default function Loader () {
    return(
        <Test>
            Loading...
        </Test>
    )
}